export const spacingTiny = '8';
export const spacingSmall = '16';
export const spacingMedium = '24';
export const spacingLarge = '32';
export const spacingHuge = '40';
export const colorPaper110 = '#f6f3f1';
export const colorRed100 = '#f6c8d9';
export const colorRed500 = '#d81b60';
export const colorRed700 = '#a61d54';
export const colorBlue600 = '#2e59c9';
export const colorPurple100 = '#cab4f1';
export const colorPurple400 = '#8b54f0';
export const colorPurple800 = '#58349a';
export const colorTeal100 = '#d5fafa';
export const colorTeal200 = '#2bcfce';
export const colorTeal500 = '#047d8c';
export const colorTeal900 = '#014f59';
export const colorVolcano900 = '#2d2c34';
export const colorNeutralDark040 = 'rgba(0, 0, 0, 0.04)';
export const colorNeutralDark080 = 'rgba(0, 0, 0, 0.08)';
export const colorNeutralDark100 = 'rgba(0, 0, 0, 0.12)';
export const colorNeutralDark150 = 'rgba(0, 0, 0, 0.16)';
export const colorNeutralDark200 = 'rgba(0, 0, 0, 0.28)';
export const colorNeutralDark300 = 'rgba(0, 0, 0, 0.32)';
export const colorNeutralDark400 = 'rgba(0, 0, 0, 0.4)';
export const colorNeutralDark500 = 'rgba(0, 0, 0, 0.52)';
export const colorNeutralDark600 = 'rgba(0, 0, 0, 0.6)';
export const colorNeutralDark700 = 'rgba(0, 0, 0, 0.72)';
export const colorNeutralDark800 = 'rgba(0, 0, 0, 0.8)';
export const colorNeutralDark900 = 'rgba(0, 0, 0, 0.92)';
export const colorNeutralDark1000 = 'rgb(0, 0, 0)';
export const colorNeutralLight040 = 'rgba(255, 255, 255, 0.04)';
export const colorNeutralLight080 = 'rgba(255, 255, 255, 0.08)';
export const colorNeutralLight100 = 'rgba(255, 255, 255, 0.12)';
export const colorNeutralLight150 = 'rgba(255, 255, 255, 0.16)';
export const colorNeutralLight200 = 'rgba(255, 255, 255, 0.28)';
export const colorNeutralLight300 = 'rgba(255, 255, 255, 0.32)';
export const colorNeutralLight400 = 'rgba(255, 255, 255, 0.4)';
export const colorNeutralLight500 = 'rgba(255, 255, 255, 0.52)';
export const colorNeutralLight600 = 'rgba(255, 255, 255, 0.6)';
export const colorNeutralLight700 = 'rgba(255, 255, 255, 0.72)';
export const colorNeutralLight800 = 'rgba(255, 255, 255, 0.8)';
export const colorNeutralLight900 = 'rgba(255, 255, 255, 0.92)';
export const colorNeutralLight1000 = 'rgb(255, 255, 255)';
export const colorLegacyOrange300 = '#f16439';
export const colorLegacyOrange400 = '#d0582d';
export const breakpointHuge = '1280';
export const breakpointLarge = '1128';
export const breakpointMedium = '601';
export const fontSizeBodyCopy1 = '10';
export const fontSizeBodyCopy2 = '11';
export const fontSizeBodyCopy3 = '12';
export const fontSizeBodyCopy4 = '13';
export const fontSizeBodyCopy5 = '14';
export const fontSizeBodyCopy6 = '16';
export const fontSizeBodyCopy7 = '20';
export const fontSizeBodyCopy8 = '24';
export const lineHeightBodyCopy1 = '16';
export const lineHeightBodyCopy2 = '18';
export const lineHeightBodyCopy3 = '20';
export const lineHeightBodyCopy4 = '24';
export const lineHeightBodyCopy5 = '24';
export const lineHeightBodyCopy6 = '28';
export const lineHeightBodyCopy7 = '36';
export const lineHeightBodyCopy8 = '40';
export const fontSizeTitle1 = '14';
export const fontSizeTitle2 = '16';
export const fontSizeTitle3 = '20';
export const fontSizeTitle4 = '24';
export const fontSizeTitle5 = '28';
export const fontSizeTitle6 = '32';
export const fontSizeTitle7 = '36';
export const fontSizeTitle8 = '40';
export const lineHeightTitle1 = '24';
export const lineHeightTitle2 = '28';
export const lineHeightTitle3 = '36';
export const lineHeightTitle4 = '40';
export const lineHeightTitle5 = '44';
export const lineHeightTitle6 = '48';
export const lineHeightTitle7 = '52';
export const lineHeightTitle8 = '56';
export const fontSizeSectionTitle1 = '10';
export const fontSizeSectionTitle2 = '11';
export const fontSizeSectionTitle3 = '12';
export const fontSizeSectionTitle4 = '14';
export const lineHeightSectionTitle1 = '16';
export const lineHeightSectionTitle2 = '18';
export const lineHeightSectionTitle3 = '20';
export const lineHeightSectionTitle4 = '24';
export const fontWeightLight = '400';
export const fontWeightBold = '900';
